import { z } from "zod"
import { ParsedAPIRes } from "@/types/types"

const DemoSignUpSchema = z.object({
  email: z.string().email(`Must be a valid email address`).min(5, `Must be a valid email address`),
  firstName: z.string().min(1, `First name cannot be blank`),
  lastName: z.string().min(1, `Last name cannot be blank`),
  recaptchaResponse: z.string(),
})

type Input = z.infer<typeof DemoSignUpSchema>

export type DemoSignUpKeys = keyof Input

type ErrorCode = "EMAIL_IN_USE" | "FALLBACK_ERROR"

type Output = string

export type DemoSignUp = (input: Input) => ParsedAPIRes<Output, ErrorCode>

export function validateDemoSignUp(input: Input) {
  const { data, error } = DemoSignUpSchema.safeParse(input)

  if (error) {
    return [null, error.flatten().fieldErrors] as const
  }
  return [data, null] as const
}
